/// <amd-module name="Wit/UI/Card/WorkItemCard" />
export * from "./Components/WorkItemCard/WorkItemCard";
export { IWorkItemCardColorInformation, IWorkItemCardProps } from "./Components/WorkItemCard/WorkItemCard.Props";
